export default __webpack_public_path__ + "static/media/link.e4ae707a.svg";